import { THEME_TYPES } from '@/store/mutation-types'
import { Module, MutationTree } from 'vuex'
import { actions } from './actions'
import { getters } from './getters'
import { RootState } from 'types'
import { ThemeState, ThemeProperties } from './themeTypes'
import { isUserMobile } from '@/utils/helpers'

export const initialTheme = (): ThemeProperties => (
  {
    input: {
      color: '#222324',
      fontSize: isUserMobile() ? '16px' : '14px',
      height: '52px',
      borderRadius: '2px'
    },
    inputbackground: {
      color: '#ffffff'
    },
    labels: {
      color: '#424242',
      fontSize: '12px'
    },
    headings: {
      color: '#333',
      fontSize: '14px'
    },
    loader: {
      color: '#9c72b6'
    },
    error: {
      color: '#ff2e56'
    },
    buttons: {
      color: '#9c72b6'
    },
    headerbackground: {
      color: '#ffffff'
    },
    background: {
      color: '#ffffff'
    },
    cashierbackground: {
      color: '#ffffff'
    },
    cardbackground: {
      color: 'transparent'
    },
    border: {
      radius: '4px'
    },
    margin: {
      size: '14px'
    }
  }
)
export const state: ThemeState = {
  colors: {
    ...initialTheme()
  }
}

const mutations: MutationTree<ThemeState> = {
  [THEME_TYPES.SET_THEME] (state, theme: ThemeProperties) {
    state.colors = {
      ...state.colors,
      ...theme
    }
  }
}

const namespaced: boolean = true

export const theme: Module<ThemeState, RootState> = {
  namespaced,
  state,
  actions,
  getters,
  mutations
}
